import { render, staticRenderFns } from "./addAddressBookModal.vue?vue&type=template&id=2688f46b&scoped=true&"
import script from "./addAddressBookModal.vue?vue&type=script&lang=js&"
export * from "./addAddressBookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688f46b",
  null
  
)

export default component.exports